import CPUStatus from "./CPU/component";
import MemoryStatus from "./Memory/component";
import DiskStatus from "./Disk/component";
import SystemInformation from "./Information/component";

const routes = [
  {
    path: "/viewStatusSystemCPU",
    view: CPUStatus,
  },
  {
    path: "/viewStatusSystemMemory",
    view: MemoryStatus,
  },
  {
    path: "/viewStatusSystemDisk",
    view: DiskStatus,
  },
  {
    path: "/viewStatusSystemInfo",
    view: SystemInformation,
  },
]
export default routes;
